import styled from 'styled-components'

const Background = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom:0;
    height: 100%;
    width: 100%;
    background: url(${props => props.img});
    background-size: cover;
    background-position: center;
    opacity: 0.5; 
    z-index: -1;
  }
`;

export default Background